<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <Form
      :isOpen="openModal"
      @closeModal="closeModal()"
      @submitModal="submitModal()"
      :title="titleModal"
      :id="selectedAlertId"
      :imei="selectedAlertImei"
      :editMode="editMode"
      :dataEdit="dataEdit"
      :eventType="eventType"
      ></Form>

    <div id="loading-container" class="w-full"></div>
    <!-- <button @click="testBtn">tombol</button> -->
    <vs-tabs :value="tabIndex">
      <vs-tab label="Urgent" style="min-height: 500px" @click="tabIndex = 0">
        <div
          class="justify-end flex flex-wrap items-center mb-2"
          style="gap: 15px">
          <div class="flex flex-row items-center" style="gap: 10px">
            <label for="license_plate">License Plate</label>
            <div style="background: white; min-width: 200px; width: auto">
              <v-select
                class="drop-height-auto"
                placeholder="- Select License Plate -"
                :clearable="true"
                v-model="selected_plate"
                label="text"
                :options="plate_array" />
            </div>
          </div>
          <div class="flex flex-row items-center" style="gap: 10px">
            <label for="ndata">Amount of Data</label>
            <!-- @input-change="autoCompleteFunc" -->
            <vs-select
              autocomplete
              class="lnData"
              v-model="itemsPerPage"
              width="60px"
              @input="showDataCount">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in itemsPerPageArray" />
            </vs-select>
            <!-- <v-select
                width="60px"
                style="background: white"
                @input="(x) => (itemsPerPage = x.value)"
                :clearable="false"
                :value="getSelectValue(itemsPerPage, itemsPerPageArray)"
                :reduce="(text) => text.value"
                label="text"
                :options="itemsPerPageArray" /> -->
          </div>
          <!-- <div class="flex flex-row items-center" style="gap: 10px">
              <label for="license_plate">Sort by</label>
              <vs-select autocomplete class="lnData" v-model="sortBy" width="120px">
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in sortByArray" />
              </vs-select>
            </div> -->
          <div class="p-5 flex flex-col rounded-lg border" style="gap: 20px; width: 100%; background: white; margin-bottom: 20px;">
            <div class="flex flex-col" style="gap: 10px">
              <h4>Filter</h4>
              <p>
                Filter each to able to see specific fleet group date and
                also violation
              </p>
            </div>
            <div class="flex flex-row w-full" style="gap: 10px">
              <div class="flex flex-col w-full" style="gap: 8px">
                <label class="font-semibold" for="">From</label>
                <div class="datetimepicker">
                  <div class="custom-datetime-wrapper">
                    <input
                      type="date"
                      class="custom-date-input"
                      v-model="startDateInput"
                      :min="minStartDate"
                      :max="maxStartDate" />
                    <div
                      class="custom-time-picker"
                      @click="openTimePicker('start')">
                      <span class="time-display">{{ displayStartTime }}</span>
                      <svg
                        class="clock-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex flex-col w-full" style="gap: 8px">
                <label class="font-semibold" for="">To</label>
                <div class="datetimepicker">
                  <div class="custom-datetime-wrapper">
                    <input
                      type="date"
                      class="custom-date-input"
                      v-model="endDateInput"
                      :min="endDateMin"
                      :max="endDateMax" />
                    <div
                      class="custom-time-picker"
                      @click="openTimePicker('end')">
                      <span class="time-display">{{ displayEndTime }}</span>
                      <svg
                        class="clock-icon"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <label class="font-semibold" for="fleet_group"
                >Fleet Group</label
              >
              <v-select
                placeholder="- Fleet Group -"
                style="background: white"
                @input="(x) => (selected_fleet = x.value)"
                :clearable="false"
                :value="getSelectValue(selected_fleet, fleetData)"
                :reduce="(text) => text.value"
                label="text"
                :options="fleetData_t" />
            </div>
            <div>
              <label class="font-semibold" for="license_plate"
                >Status Alert</label
              >
              <v-select
                style="background: white"
                placeholder="- Select Status Alert -"
                @input="(x) => (status_type = x.value)"
                :clearable="false"
                :value="getSelectValue(status_type, status_list_t)"
                :reduce="(text) => text.value"
                label="text"
                :options="status_list_t" />
            </div>
            <div>
              <label class="font-semibold" for="license_plate"
                >Type of Event</label
              >
              <v-select
                style="background: white"
                placeholder="- Select Event Type -"
                :clearable="true"
                v-model="event_type"
                label="text"
                multiple
                :options="event_list_t" 
                clearable />
            </div>
            <div class="flex flex-row mt-4 mb-1" style="gap: 10px">
              <vs-button
                class="py-3 px-10 ml-auto"
                type="border"
                @click="resetData"
                >Clear</vs-button
              >
            </div>
          </div>
          <vs-button
            v-if="getRolePermission().alert.alert_history.enable_download"
            class="py-2 px-4 btn-download"
            color="danger"
            type="border"
            @click="download_data">
            <div class="flex flex-row">
              <p class="mr-4 font-medium">Download</p>
              <feather-icon
                icon="DownloadIcon"
                svgClasses="h-4 w-4"></feather-icon>
            </div>
          </vs-button>
          <vs-button radius color="danger" type="filled" @click="refreshData"
            ><feather-icon
              icon="RefreshCwIcon"
              svgClasses="h-4 w-5"></feather-icon
          ></vs-button>
        </div>
        <vs-table ref="table" :max-items="itemsPerPage" :data="data">
          <template slot="thead">
            <vs-th>{{ $t('LICENSE PLATE') }}</vs-th>
            <vs-th>{{ $t('UNIT TYPE') }}</vs-th>
            <vs-th>{{ $t('FLEET GROUP') }}</vs-th>
            <vs-th>{{ $t('ALERT') }}</vs-th>
            <vs-th>{{ $t('DRIVER NAME') }}</vs-th>
            <!-- <vs-th>{{ $t('DRIVER PHONE') }}</vs-th> -->
            <vs-th>{{ $t('SPEED') }}</vs-th>
            <vs-th>{{ $t('DURATION') }}</vs-th>
            <vs-th>{{ $t('DATE') }}</vs-th>
            <vs-th>{{ $t('LOCATION') }}</vs-th>
            <vs-th>{{ $t('ACTION') }}</vs-th>
            <vs-th>{{ $t('NOTES') }}</vs-th>
            <!-- <vs-th style="width: 204px">Status</vs-th>  asd-->
          </template>
          <template slot-scope="{ data }">
            <tbody id="isi_table">
              <vs-tr
                class="cursor-default"
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].license_plate">
                  <a :href="`/monitoring-vehicle/${data[indextr].vehicle_id}`">
                    <p class="product-name font-medium">
                      {{ tr.license_plate }}
                    </p>
                  </a>
                </vs-td>
                <vs-td :data="data[indextr].license_plate">
                  <a :href="`/monitoring-vehicle/${data[indextr].vehicle_id}`">
                    <p class="product-name font-medium">
                      {{ tr.vehicle_type }}
                    </p>
                  </a>
                </vs-td>
                <vs-td :data="data[indextr].fleet_group_name">
                  <p class="product-name font-medium">
                    {{ tr.fleet_group_name }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].event_type">
                  <p class="product-name font-medium">
                    {{
                      tr.event_type.includes('POI') ||
                      tr.event_type.includes('GEO')
                        ? tr.event
                        : $t(tr.event_name)
                    }}
                  </p>
                </vs-td>
                <vs-td :data="data[indextr].driver_name">
                  <p class="product-name font-medium">
                    {{ tr.driver_name ? tr.driver_name : '-' }}
                  </p>
                </vs-td>
                <!-- <vs-td :data="data[indextr].driver_phone">
                  <p class="product-name font-medium">
                    {{ tr.driver_phone ? tr.driver_phone : '-' }}
                  </p>
                </vs-td> -->
                <vs-td :data="data[indextr].speed">
                  <p class="product-name font-medium">{{ tr.speed }} Km/h</p>
                </vs-td>
                <vs-td :data="data[indextr].duration">
                  <p class="product-name font-medium">
                    {{ getSimpleDurationV2(tr.duration) }}
                  </p>
                </vs-td>
                <vs-td class="py-2" :data="data[indextr].device_time">
                  <p>{{ formatDate(tr.device_time) }} WIB</p>
                </vs-td>
                <vs-td class="py-2" :data="data[indextr].location">
                  <p
                    style="min-width: 250px; max-width: 450px"
                    v-if="tr.address">
                    {{ tr.address }}
                  </p>
                  <p v-else class="loader_1"></p>

                  <div class="flex flex-row" style="gap: 10px">
                    <a target="_blank" :href="tr.gmaps_url">{{
                      $t('Show Google Maps')
                    }}</a>
                    <p style="width: fit-content">|</p>
                    <a target="_blank" :href="tr.streetview_url">{{
                      $t('Show Street View')
                    }}</a>
                  </div>
                  <!-- <p style="min-width: 250px">{{ tr.address }}</p> -->
                </vs-td>
                <vs-td
                  class="py-5 relative flex justify-center"
                  :data="data[indextr].verified_by">
                  <div class="flex justify-center" style="gap: 10px">
                    <div class="w-1/2">
                      <div
                      class="z-10 font-semibold items-center py-2 px-5 my-1 justify-center flex rounded-lg cursor-pointer"
                      :style="{
                        'background-color':
                          tr.verified_by.type === 'danger' ||
                          tr.verified_by.type === 'success'
                            ? 'transparent'
                            : `var(--${tr.verified_by.type})`,
                        color: `var(--${tr.verified_by.type}-content)`,
                        width: 'fit-content',
                      }"
                      @click="handleSelected(tr)">
                      <!-- {{ tr.verified_by }} -->
                      <div
                        v-if="tr.verified_by.type == 'danger'"
                        class="text-center ml-2">
                        <div class="flex justify-center">
                          <feather-icon
                            class="mr-4"
                            :icon="tr.verified_by.icon"
                            svgClasses="h-8 w-8"
                            :style="{
                              color: `var(--${tr.verified_by.type}-content)`,
                            }"></feather-icon>
                          <div
                            class="text-center"
                            v-if="tr.verified_by.name"
                            :style="{
                              color: `var(--${tr.verified_by.type}-content)`,
                            }">
                            <p>
                              {{ $t('Verified by') }}
                            </p>
                            {{ tr.verified_by.name }}
                          </div>
                          <div
                            v-if="!tr.verified_by.name"
                            :style="{
                              color: `var(--${tr.verified_by.type}-content)`,
                            }">
                            {{ $t('Not Verified') }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="tr.verified_by.type == 'success'"
                        class="">
                        <div class="flex justify-center">
                          <feather-icon
                            class="mr-4"
                            :icon="tr.verified_by.icon"
                            svgClasses="h-8 w-8"
                            :style="{
                              color: `var(--${tr.verified_by.type}-content)`,
                            }"></feather-icon>
                          <div
                            class="text-center"
                            :style="{
                              color: `var(--${tr.verified_by.type}-content)`,
                            }">
                            <p>
                              {{ $t('Verified by') }}
                            </p>
                            {{ tr.verified_by.name }}
                          </div>
                          <!-- <div style="border-left: 1px solid green;" class="text-center mx-2"></div> -->
                        </div>
                      </div>
                      <div
                        v-else
                        class="flex justify-center"
                        :style="{
                          color: `var(--${tr.verified_by.type}-content)`,
                        }">
                        <feather-icon
                          class="mr-4"
                          :icon="tr.verified_by.icon"
                          svgClasses="h-8 w-8"
                          :style="{
                            color: `var(--${tr.verified_by.type}-content)`,
                          }"></feather-icon>
                          <div
                            class="text-center"
                            :style="{
                              color: `var(--${tr.verified_by.type}-content)`,
                            }">
                            <p>
                              {{ $t('Verification') }}
                            </p>
                        {{ $t('Required') }}
                      </div>
                      </div>
                    </div>
                    <span
                      v-show="hideBtn == tr._id"
                      style="color: #1c44a3; font-size: 12px">
                      Verifying ...
                    </span>
                  </div>
                  <div class="w-1/2">
                    <div
                      class="z-10 font-semibold items-center py-2 px-5 my-1 justify-center flex rounded-lg cursor-pointer"
                      :style="{
                        'background-color':
                          tr.validation_by.type_validation === 'danger' ||
                          tr.validation_by.type_validation === 'success'
                            ? 'transparent'
                            : `var(--${tr.validation_by.type_validation})`,
                        color: `var(--${tr.validation_by.type_validation}-content)`,
                        width: 'fit-content',
                      }"
                      @click="handleSelected(tr)">
                      <!-- {{ tr.verified_by }} -->
                      <div
                        v-if="tr.validation_by.type_validation == 'danger'"
                        class="text-center ml-2">
                        <div class="flex justify-center">
                          <feather-icon
                            class="mr-4"
                            :icon="tr.validation_by.icon_validation"
                            svgClasses="h-8 w-8"
                            :style="{
                              color: `var(--${tr.validation_by.type_validation}-content)`,
                            }"></feather-icon>
                          <div
                            class="text-center"
                            v-if="tr.validation_by.name"
                            :style="{
                              color: `var(--${tr.validation_by.type_validation}-content)`,
                            }">
                            <p>
                              {{ $t('Validation by') }}
                            </p>
                            {{ tr.validation_by.name }}
                          </div>
                          <div
                            v-if="!tr.validation_by.name"
                            :style="{
                              color: `var(--${tr.validation_by.type_validation}-content)`,
                            }">
                            {{ $t('Not Validation') }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="tr.validation_by.type_validation == 'success'"
                        class="">
                        <div class="flex justify-center">
                          <feather-icon
                            class="mr-4"
                            :icon="tr.validation_by.icon_validation"
                            svgClasses="h-8 w-8"
                            :style="{
                              color: `var(--${tr.validation_by.type_validation}-content)`,
                            }"></feather-icon>
                          <div
                            class="text-center"
                            :style="{
                              color: `var(--${tr.validation_by.type_validation}-content)`,
                            }">
                            <p>
                              {{ $t('Validation by') }}
                            </p>
                            {{ tr.validation_by.name }}
                          </div>
                          <!-- <div style="border-left: 1px solid green;" class="text-center mx-2"></div> -->
                        </div>
                      </div>
                      <div
                        v-else
                        class="flex justify-center"
                        :style="{
                          color: `var(--${tr.validation_by.type_validation}-content)`,
                        }">
                        <feather-icon
                          class="mr-4"
                          :icon="tr.validation_by.icon_validation"
                          svgClasses="h-8 w-8"
                          :style="{
                            color: `var(--${tr.validation_by.type_validation}-content)`,
                          }"></feather-icon>
                          <div
                            class="text-center"
                            :style="{
                              color: `var(--${tr.validation_by.type_validation}-content)`,
                            }">
                            <p>
                              {{ $t('Validation') }}
                            </p>
                        {{ $t('Required') }}
                      </div>
                      </div>
                    </div>
                    <span
                      v-show="hideBtn == tr._id"
                      style="color: #1c44a3; font-size: 12px">
                      Verifying ...
                    </span>
                  </div>
                </div>

                </vs-td>
                <vs-td class="py-2" :data="data[indextr].note_validation">
                  <div v-if="tr.note_validation">
                    <p
                      class="text-danger underline cursor-pointer"
                      @click="handleSelected(tr)">
                      {{ $t('See Notes') }}
                    </p>
                  </div>
                  <div v-else>
                    <p>-</p>
                  </div>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <div v-if="showTimePicker" class="time-picker-overlay" @click="closeTimePicker">
          <div class="time-picker-modal" @click.stop>
            <div class="time-picker-header">
              <h3>Select Time</h3>
              <button class="close-btn" @click="closeTimePicker">&times;</button>
            </div>
            <div class="time-picker-body">
              <div class="time-scroll-container">
                <div class="time-column">
                  <div class="time-column-header">Hour</div>
                  <div class="time-scroll" ref="hourScroll">
                    <div
                      v-for="hour in hours"
                      :key="hour"
                      class="time-item"
                      :class="{ active: selectedHour === hour }"
                      @click="selectHour(hour)">
                      {{ hour }}
                    </div>
                  </div>
                </div>
                <div class="time-separator">:</div>
                <div class="time-column">
                  <div class="time-column-header">Minute</div>
                  <div class="time-scroll" ref="minuteScroll">
                    <div
                      v-for="minute in minutes"
                      :key="minute"
                      class="time-item"
                      :class="{ active: selectedMinute === minute }"
                      @click="selectMinute(minute)">
                      {{ minute }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="time-picker-footer">
              <button class="time-btn time-btn-cancel" @click="closeTimePicker">Cancel</button>
              <button class="time-btn time-btn-confirm" @click="confirmTime">Confirm</button>
            </div>
          </div>
        </div>

        <template>
          <vs-pagination :total="last_page" v-model="page"></vs-pagination>
        </template>
      </vs-tab>
      <vs-tab label="Summary" style="min-height: 500px" @click="tabIndex = 1">
        <AlertSummary />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import * as moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/database'
import { mapState } from 'vuex'
import * as REPO from '../../../repository/index'
import XLSX from 'xlsx'
import Form from './VerifyForm.vue'
import AlertSummary from '../alert-summary/AlertSummary.vue'

export default {
  components: {
    Form,
    AlertSummary,
  },
  props: {},
  watch: {
    page(val) {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })

      // change param conditions event_type
      const param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }

      if( this.event_type.length > 0 ) {
        param.event_type = this.event_type.map((x) => x.value);
      }

      this.getData(param)

      // this.getData({limit:15,page:this.page, license_plate:this.search_name,fleet_group_id:this.selected_fleet,start_date:this.dateStart,end_date:this.dateEnd})
    },
    selected_plate(val) {
      if (val == null) {
        this.search_name = ''
        this.searchData()
      } else {
        this.search_name = val.text
        this.searchData()
      }
    },
    startDateInput() {
      if (this.suppressStartInputWatcher) return
      this.updateStartFromInputs()
    },
    startTimeInput() {
      if (this.suppressStartInputWatcher) return
      this.updateStartFromInputs()
    },
    endDateInput() {
      if (this.suppressEndInputWatcher) return
      this.updateEndFromInputs()
    },
    endTimeInput() {
      if (this.suppressEndInputWatcher) return
      this.updateEndFromInputs()
    },
    dateStart(val) {
      this.syncStartInputsFromDate(val)

      if (!val) {
        this.maxEnd = null
        return
      }

      const startMoment = moment(val)
      const maxCandidate = moment(val).add(14, 'days')
      const now = moment()
      const maxEndMoment = now.isBefore(maxCandidate) ? now : maxCandidate

      this.maxEnd = maxEndMoment.format('YYYY-MM-DD HH:mm:ss')

      setTimeout(() => {
        this.dateEnd = this.maxEnd
        this.filterData()
      }, 50)
    },
    dateEnd(val) {
      this.syncEndInputsFromDate(val)
      this.filterData()
    },
    selected_fleet(val) {
      this.filterData()
    },
    status_type(val) {
      this.filterData()
    },
    event_type(val) {
      this.filterData()
    },
  },
  mounted() {
    this.generateTimeOptions()
    this.getFilterData()
    var self = this
    let start = moment().format('YYYY-MM-DD') + ' 00:00:00'
    this.dateStart = start
    let ends = moment().format('YYYY-MM-DD HH:mm:ss')
    // this.$root.$on('reloadNotifBawah', () => {
    //   this.resetData()
    // })

    setTimeout(() => {
      const inputs = document.getElementsByTagName('input')
      const input = Array.from(inputs).find(
        (x) => x['placeholder'] == '- Select License Plate -'
      )
      //
      input.removeEventListener('keydown', self.onKeyDownLicense, true)
      input.addEventListener('keydown', self.onKeyDownLicense, true)
      input.addEventListener(
        'keyup',
        (e) => (e.target.value = e.target.value.toUpperCase()),
        true
      )
    }, 50)

    this.$root.$on('filterNotifBawah', (val, filters) => {
      if (val) {
        this.selected_plate = null
        this.selected_plate = {
          text: val,
          value: val,
        }
      }
      if (filters) {
        this.fleet_group_id = filters.fleet_group_id
        this.dateStart = moment(filters.start_date).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        this.dateEnd = moment(filters.end_date).format('YYYY-MM-DD HH:mm:ss')
        this.event_type = filters.event_type
      }
      setTimeout(() => {
        this.refreshData()
      }, 200)
    })
    this.$root.$on('goToUrgent', (val) => {
      this.tabIndex = 0
      this.selected_plate = null
      this.selected_plate = {
        text: val.license_plate,
        value: val.license_plate,
      }
      this.dateStart = moment(val.dateStart).format('YYYY-MM-DD HH:mm:ss')
      this.dateEnd = moment(val.dateEnd).format('YYYY-MM-DD HH:mm:ss')
      this.event_type = val.event_type

      setTimeout(() => {
        this.refreshData()
      }, 200)
    })

    this.$root.$on('goToSummary', (val) => {
      this.tabIndex = 1
      setTimeout(() => {
        this.$root.$emit('refreshSummary', val)
      }, 1000)
    })

    let role = JSON.parse(localStorage.getItem('userInfo')).role.role_menu
    //
    let url = this.$router.currentRoute.path
    let check = role.filter((x) => x.menu_link == url)
    //
    if (check.length > 0) {
      if (check[0].is_update == 0) {
        this.disableBtn = true
      }
    }
    //
    // menu_link
    //
    REPO.getListAlert().then((res) => {
      let tmp = res.data.data
      this.event_list = []
      tmp.forEach((x) => {
        // Cek apakah huruf pertama adalah huruf kecil, kalau iya berati alert dashcam
        const isFirstLetterLowercase = /^[a-z]/.test(x.alert_code)

        this.event_list.push({
          text: isFirstLetterLowercase ? "DASHCAM - " + x.alert_name : x.alert_name,
          value: x.alert_code,
        })
      })
    })
    this.selected_fleet = self.$dataLocal.UserData().id
    this.fleet_group_id = this.$dataLocal.UserData().id
    this.fleetData = [
      {
        text: 'All',
        value: this.$dataLocal.UserData().id,
      },
    ]
    REPO.getListFleetChield(this.$dataLocal.UserData().id).then((res) => {
      if (res.data.status == 'true') {
        let tmp = res.data.data.map((h) => {
          return {
            text: h.fleet_group_name,
            value: h.id,
          }
        })
        // let hasil = []
        //
        // this.rekursive(tmp, hasil, 0)
        //
        this.fleetData = [...this.fleetData, ...tmp]
        let end_date = moment().format('YYYY-MM-DD HH:mm:ss')

        this.getData({
          limit: this.itemsPerPage,
          page: 1,
          fleet_group_id: self.selected_fleet,
          start_date: this.dateStart,
          end_date: end_date,
          status_verified: this.status_type,
        })

        if(this.event_type.length > 0){
          param.event_type = this.event_type.map(x => x.value);
        }

        setTimeout(() => {
          this.maxEnd = ends
          this.dateEnd = end_date
          //
        }, 2500)
      }
    })

    this.maxEnd = ends
    this.dateEnd = ends
    // setTimeout(() => {
    //   this.dateEnd = ends
    //   //
    // }, 2500)
  },
  computed: {
    ...mapState(['userData']),
    displayStartTime() {
      return this.startTimeInput || '00:00'
    },
    displayEndTime() {
      return this.endTimeInput || '00:00'
    },
    minStartDate() {
      return moment().subtract(30, 'months').format('YYYY-MM-DD')
    },
    maxStartDate() {
      return moment().format('YYYY-MM-DD')
    },
    endDateMin() {
      return this.startDateInput || this.minStartDate
    },
    endDateMax() {
      if (!this.maxEnd) {
        return this.maxStartDate
      }
      const max = moment(this.maxEnd, 'YYYY-MM-DD HH:mm:ss', true)
      if (!max.isValid()) {
        return this.maxStartDate
      }
      return max.format('YYYY-MM-DD')
    },
    status_list_t() {
      return this.status_list.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
    event_list_t() {
      return this.event_list.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
    fleetData_t() {
      return this.fleetData.map((x) => {
        return {
          text: this.$t(x.text),
          value: x.value,
        }
      })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeModal()
    setTimeout(() => {
      next()
    }, 100)
  },
  data() {
    return {
      tabIndex: 0,
      selectedAlertId: '',
      selectedAlertImei: '',
      openModal: false,
      titleModal: 'Add Notes',
      hideBtn: null,
      alert_array: [],
      fleet_array: [],
      event_list: [],
      fleetData: [],
      plate_array: [],
      data: [],
      dataEdit: {},
      editMode: false,
      filter_array: [],
      listPaired: [],
      s_alert: '',
      event_type: [],
      searchA: '',
      search_name: '',
      selected_plate: null,
      strips: [],
      dateStart: null,
      load_done: false,
      maxEnd: null,
      dateEnd: null,
      fleet_group_id: '',
      viewDetail: false,
      disableBtn: false,
      search: '',
      selected_filter: '',
      selected_fleet: '',
      currentPage: 1,
      last_page: 1,
      page: 1,
      itemsPerPage: 15,
      itemsPerPageArray: [
        {
          text: '15',
          value: 15,
        },
        {
          text: '30',
          value: 30,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: '100',
          value: 100,
        },
      ],
      sortBy: 'date',
      sortByArray: [
        {
          text: 'Date',
          value: 'date',
        },
        {
          text: 'License Plate',
          value: 'license_plate',
        },
        {
          text: 'Fleet Group',
          value: 'fleet_group_name',
        },
        {
          text: 'Alert',
          value: 'event_type',
        },
        {
          text: 'Speed',
          value: 'speed',
        },
        {
          text: 'RPM',
          value: 'engine_speed_x',
        },
        {
          text: 'Engine Temp',
          value: 'engine_coolant_temperature_x',
        },
        {
          text: 'Chiller Temp',
          value: 'dallas_temperature_1',
        },
      ],
      searchB: '',
      fleetGroup: '',

      status_list: [
        {
          text: 'All',
          value: '',
        },
        {
          text: 'Verified',
          value: 'verified',
        },
        {
          text: 'Not Yet Verified',
          value: 'not_yet_verified',
        },
        {
          text: 'Not Verified',
          value: 'unverified',
        },
      ],
      status_type: '',
      startDateInput: '',
      startTimeInput: '00:00',
      endDateInput: '',
      endTimeInput: '00:00',
      showTimePicker: false,
      currentTimeField: null,
      selectedHour: '00',
      selectedMinute: '00',
      hours: [],
      minutes: [],
      suppressStartInputWatcher: false,
      suppressEndInputWatcher: false,

      // event type untuk deteksi MB_CN atau bukan  
      event_type: ''
    }
  },
  methods: {
    testBtn() {},
    generateTimeOptions() {
      this.hours = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'))
      this.minutes = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0'))
    },
    openTimePicker(field) {
      this.currentTimeField = field
      const timeValue = field === 'start' ? this.startTimeInput : this.endTimeInput
      const [hour = '00', minute = '00'] = (timeValue || '00:00').split(':')
      this.selectedHour = hour
      this.selectedMinute = minute
      this.showTimePicker = true
      this.$nextTick(() => {
        this.scrollToSelected()
      })
    },
    closeTimePicker() {
      this.showTimePicker = false
      this.currentTimeField = null
    },
    selectHour(hour) {
      this.selectedHour = hour
    },
    selectMinute(minute) {
      this.selectedMinute = minute
    },
    scrollToSelected() {
      const hourScroll = this.$refs.hourScroll
      const minuteScroll = this.$refs.minuteScroll

      if (hourScroll) {
        const hourIndex = this.hours.indexOf(this.selectedHour)
        if (hourIndex >= 0) {
          hourScroll.scrollTop = Math.max(hourIndex * 40 - 80, 0)
        }
      }

      if (minuteScroll) {
        const minuteIndex = this.minutes.indexOf(this.selectedMinute)
        if (minuteIndex >= 0) {
          minuteScroll.scrollTop = Math.max(minuteIndex * 40 - 80, 0)
        }
      }
    },
    confirmTime() {
      const time = `${this.selectedHour}:${this.selectedMinute}`

      if (this.currentTimeField === 'start') {
        this.startTimeInput = time
      } else if (this.currentTimeField === 'end') {
        this.endTimeInput = time
      }

      this.closeTimePicker()
    },
    syncStartInputsFromDate(val) {
      this.suppressStartInputWatcher = true

      if (!val) {
        this.startDateInput = ''
        this.startTimeInput = '00:00'
      } else {
        const parsed = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        const momentValue = parsed.isValid() ? parsed : moment(val)

        if (momentValue.isValid()) {
          this.startDateInput = momentValue.format('YYYY-MM-DD')
          this.startTimeInput = momentValue.format('HH:mm')
        } else {
          this.startDateInput = ''
          this.startTimeInput = '00:00'
        }
      }

      this.$nextTick(() => {
        this.suppressStartInputWatcher = false
      })
    },
    syncEndInputsFromDate(val) {
      this.suppressEndInputWatcher = true

      if (!val) {
        this.endDateInput = ''
        this.endTimeInput = '00:00'
      } else {
        const parsed = moment(val, 'YYYY-MM-DD HH:mm:ss', true)
        const momentValue = parsed.isValid() ? parsed : moment(val)

        if (momentValue.isValid()) {
          this.endDateInput = momentValue.format('YYYY-MM-DD')
          this.endTimeInput = momentValue.format('HH:mm')
        } else {
          this.endDateInput = ''
          this.endTimeInput = '00:00'
        }
      }

      this.$nextTick(() => {
        this.suppressEndInputWatcher = false
      })
    },
    updateStartFromInputs() {
      if (!this.startDateInput) {
        return
      }

      const time = this.startTimeInput || '00:00'
      let startMoment = moment(
        `${this.startDateInput} ${time}`,
        'YYYY-MM-DD HH:mm'
      )

      if (!startMoment.isValid()) {
        return
      }

      const minMoment = moment().subtract(20, 'months')
      const now = moment()

      if (startMoment.isBefore(minMoment)) {
        startMoment = minMoment
      }

      if (startMoment.isAfter(now)) {
        startMoment = now
      }

      const formatted = startMoment.format('YYYY-MM-DD HH:mm:ss')

      if (this.dateStart !== formatted) {
        this.dateStart = formatted
      }
    },
    updateEndFromInputs() {
      if (!this.endDateInput) {
        return
      }

      const time = this.endTimeInput || '00:00'
      let endMoment = moment(
        `${this.endDateInput} ${time}`,
        'YYYY-MM-DD HH:mm'
      )

      if (!endMoment.isValid()) {
        return
      }

      const startMoment = this.dateStart
        ? moment(this.dateStart, 'YYYY-MM-DD HH:mm:ss', true).isValid()
          ? moment(this.dateStart, 'YYYY-MM-DD HH:mm:ss', true)
          : moment(this.dateStart)
        : null

      // if (startMoment && endMoment.isBefore(startMoment)) {
      //   endMoment = startMoment.clone()
      // }

      const maxEndMoment = this.maxEnd
        ? moment(this.maxEnd, 'YYYY-MM-DD HH:mm:ss', true).isValid()
          ? moment(this.maxEnd, 'YYYY-MM-DD HH:mm:ss', true)
          : moment(this.maxEnd)
        : null

      if (maxEndMoment && endMoment.isAfter(maxEndMoment)) {
        endMoment = maxEndMoment.clone()
      }

      const formatted = endMoment.format('YYYY-MM-DD HH:mm:ss')

      if (this.dateEnd !== formatted) {
        this.dateEnd = formatted
      }
    },
    onKeyDownLicense(e) {
      this.automateLicensePlate(e, e.target, this.strips)
    },
    getFilterData() {
      this.fleet_group_id = this.$dataLocal.UserData().id
      REPO.getFilterClusterLicVin(this.$dataLocal.UserData().id).then((res) => {
        if (res.data.status == 'true') {
          let arrays = res.data.data
          let license_plate = []

          arrays.forEach((x) => {
            let license_plate_f = license_plate.some(
              (g) => g.value == x.vehicle_id
            )
            if (!license_plate_f)
              license_plate.push({ text: x.license_plate, value: x.vehicle_id })
          })
          this.plate_array = [...license_plate]
        } else {
        }
      })
    },
    handleFilterClick() {
      //
      const endData = moment().format('YYYY-MM-DD HH:mm:ss')
      const prevData = this.dateEnd
      setTimeout(() => {
        // this.maxEnd = endData
        this.dateEnd = prevData
      }, 100)
      // }
    },
    download_data() {
      // const self = this
      // var ProgressBar = require('progressbar.js')
      // var bar = new ProgressBar.Line('#loading-container', {
      //   strokeWidth: 1,
      //   easing: 'easeInOut',
      //   duration: 1400,
      //   borderRadius: '10px',
      //   color: 'rgba(234, 84, 85, 1)',
      //   trailColor: '#eee',
      //   trailWidth: 1,
      //   svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
      //   text: {
      //     style: {
      //       color: '#999',
      //       position: 'absolute',
      //       right: '0',
      //       top: '30px',
      //       padding: 0,
      //       margin: 0,
      //       transform: null,
      //     },
      //     autoStyleContainer: false,
      //   },
      //   from: { color: '#FFEA82' },
      //   to: { color: '#ED6A5A' },
      //   step: (state, bar) => {
      //     let value = Math.round(bar.value() * 100)
      //     if (value >= 100) {
      //       bar.setText('Writing Excel file, Please wait...')
      //     } else {
      //       bar.setText('Collecting Data ' + value + ' %')
      //     }
      //     // bar.setText('Collecting Data ' + Math.round(bar.value() * 100) + ' %')
      //   },
      // })

      // bar.animate(0.0)

      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.loadingBtnStart('btn-download')

      // Urgent_all(startdate-enddate)userid.xlsx
      const joinEventType =
        this.event_type.length > 0
          ? this.event_type.map((x) => x.value).join('&')
          : 'all'

      const filename = `Urgent_${joinEventType}(${
        moment(this.dateStart).format('YYYYMMDD') +
        '-' +
        moment(this.dateEnd).format('YYYYMMDD')
        })${this.$dataLocal.UserData().id.split('-')[0]}${moment().valueOf()}`

      let param = {
        type: 'local',
        start_date: moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
        title: filename,
        file_export: 'urgent',
        status_verified: this.status_type,
      }

      // const rowsToDownload = this.last_page * this.itemsPerPage // Total number of rows to download
      // const averageTimePerRow = (2.4 * 60 * 1000) / 33375 // Average time per row in milliseconds based on your observation
      // const totalDownloadDuration = rowsToDownload * averageTimePerRow // Total download duration in milliseconds
      // const intervalTime = 200 // Interval time in milliseconds
      // const totalSteps = totalDownloadDuration / intervalTime
      // const increment = 1 / totalSteps

      // let currentProgress = 0

      // const interval = setInterval(() => {
      //   currentProgress += increment
      //   bar.animate(currentProgress)
      //   if (currentProgress >= 1) {
      //     bar.set(1) // Ensure the bar value is exactly 1
      //     clearInterval(interval)
      //   }
      // }, intervalTime)

      // //
      if (this.event_type.length > 0) {
        param.event_types = this.event_type.map((x) => x.value)
      } else {
        param.event_types = JSON.parse(this.getRoleCode())
      }

      const user_id = this.$dataLocal.UserData().id

      if (this.selected_fleet === user_id) {
        const fgids = JSON.parse(this.$dataLocal.UserData().fleet_group_ids)
        param.fleet_group_ids = fgids
      } else {
        param.fleet_group_ids = [this.selected_fleet]
      }
      delete param.license_plate

      if (this.selected_plate != null) {
        param.license_plate = [this.selected_plate.text]
        delete param.fleet_group_ids
      }

      REPO.exportSenderV2(param)
        .then((res) => {
          // navigate to download page /export/history
          this.$router.push('/export/history')
          //
          // if (res.data.status == true) {

          // }
        })
        .catch((err) => {
          this.$toast.error('Problem Exporting Data')
        })
        .finally(() => {
          // bar.animate(1.0)
          // setTimeout(() => {
          //   clearInterval(interval)
          //   bar.destroy()
          // }, 500)
          this.loadingBtnStop('btn-download')
          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
        })
    },
    download(dataurl, filename) {
      const link = document.createElement('a')
      link.href = dataurl
      link.download = filename
      link.click()
    },
    submitModal() {
      this.openModal = false
      this.editMode = false

      this.getData({
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      })

      if( this.event_type.length > 0 ) {
        param.event_type = this.event_type.map((x) => x.value);
      }
    },
    checkSuhu(val) {
      let tmp = val
      if (parseInt(val) > 99) {
        tmp = Math.round(parseInt(val) / 10)
      }
      return tmp
    },
    resetData() {
      console.log('reset data called')
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      let start = moment().format('YYYY-MM-DD') + ' 00:00:00'
      this.dateStart = start
      let ends = moment().format('YYYY-MM-DD HH:mm:ss')
      this.dateEnd = ends
      this.event_type = []
      this.page = 1
      this.selected_fleet = this.$dataLocal.UserData().id

      this.refreshData()
    },
    getByCurrentPage() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.selected_fleet = this.$dataLocal.UserData().id
      this.search_name = ''
      let param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }

      if( this.event_type.length > 0 ) {
        param.event_type = this.event_type.map((x) => x.value);
      }
      //
      this.getData(param)
    },
    refreshData() {
      //
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      //
      let end_date = moment().format('YYYY-MM-DD HH:mm:ss')
      this.maxEnd = end_date
      this.dateEnd = end_date

      const param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: this.event_type,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }
      this.getData(param)
    },
    searchData() {
      this.refreshData()
    },
    showDataCount(val) {
      //
      this.itemsPerPage = val
      this.searchData()
    },
    filterData() {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      this.page = 1
      const param = {
        limit: this.itemsPerPage,
        page: this.page,
        license_plate: this.search_name,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        end_date: this.dateEnd,
        status_verified: this.status_type,
      }

      if( this.event_type.length > 0 ) {
        param.event_type = this.event_type.map((x) => x.value);
      }
      
      this.getData(param)
    },
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + (parseInt(counter) + 1) + ' ' + x.fleet_group_name
        let tmp = {
          text: text,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    getData(param) {
      this.$vs.loading({
        container: '#isi_table',
        scale: 1,
      })
      // param.limit = this.itemsPerPage
      if (!this.event_type.length) delete param.event_type
      if (this.search_name == '') delete param.license_plate

      //

      REPO.getAlertHistory({ ...param, alert_config: this.getRoleCode() })
        .then(async (res) => {
          let tmp = res.data.data.data
          if (tmp == null || tmp == undefined || tmp.length == 0) {
            this.data = []
            this.last_page = 1
            this.$vs.loading.close('#isi_table > .con-vs-loading')
            this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
            return
          }
          tmp.map((x) => {
            console.log("==================",x)
            let type =
              x.note != undefined && x.note != ''
                ? 'success'
                : // : moment(x.device_time).isAfter(moment().subtract(1, 'hours')) && ((x.note != "" && x.note != undefined) || (x.note_validation == "" && x.note_validation == undefined)) ? 'validation'
                  moment(x.device_time).isAfter(moment().subtract(1, 'hours'))
                  ? 'primary'
                  : // : moment(x.device_time).isAfter(moment().subtract(2, 'hours')) && ((x.note != "" || x.note != undefined) || (x.note_validation == "" || x.note_validation == undefined)) ? 'validation'
                    moment(x.device_time).isAfter(moment().subtract(2, 'hours'))
                    ? 'warning'
                    : // : moment(x.device_time).isAfter(moment().subtract(4, 'days')) && ((x.note != "" && x.note != undefined) || (x.note_validation == "" && x.note_validation == undefined)) ? 'validation'
                      moment(x.device_time).isAfter(
                          moment().subtract(4, 'hours')
                        )
                      ? 'last-validation'
                      : 'danger'
            
            // Override type jika event_type MB_CN maka validasi berlaku selama 14 hari
            if(x.event_type == 'MB_CN'){
              type = x.note != undefined && x.note != ''
                ? 'success'                                           // Sudah verified
                : moment(x.device_time).isAfter(moment().subtract(3, 'days'))
                  ? 'primary'                                         // 0-3 hari: Urgent
                  : moment(x.device_time).isAfter(moment().subtract(7, 'days'))
                    ? 'warning'                                       // 3-7 hari: Warning
                    : moment(x.device_time).isAfter(moment().subtract(14, 'days'))
                      ? 'last-validation'                             // 7-14 hari: Last chance
                      : 'danger'                                      // > 14 hari: Expired
            }

            let type_validation =
              x.note_validation != '' && x.note_validation != undefined
                ? 'success'
                : moment(x.device_time).isAfter(moment().subtract(1, 'hours'))
                  ? 'primary'
                  : moment(x.device_time).isAfter(moment().subtract(2, 'hours'))
                    ? 'warning'
                    : moment(x.device_time).isAfter(
                          moment().subtract(4, 'days')
                        )
                      ? 'last-validation'
                      : 'danger'

            // Override jika event_type MB_CN maka validasi berlaku selama 14 hari
            if(x.event_type == 'MB_CN'){
              type_validation = x.note_validation != '' && x.note_validation != undefined
                ? 'success'
                : moment(x.device_time).isAfter(moment().subtract(3, 'days'))
                  ? 'primary'
                  : moment(x.device_time).isAfter(moment().subtract(7, 'days'))
                    ? 'warning'
                    : moment(x.device_time).isAfter(moment().subtract(14, 'days'))
                      ? 'last-validation'
                      : 'danger'
            }

            ;(x.verified_by = {
              name: x.verified_by,
              note: x.note,
              type: type,
              icon:
                type == 'success'
                  ? 'CheckCircleIcon'
                  : type == 'danger'
                    ? 'XCircleIcon'
                    : 'AlertTriangleIcon',
              // : type_assign == 'Validation'
              //   ? 'UploadCloudIcon'
              //   : 'AlertTriangleIcon',
            }),
              (x.validation_by = {
                name: x.validation_by,
                note: x.note_validation,
                type_validation: type_validation,
                icon_validation:
                  type_validation == 'success'
                    ? 'CheckCircleIcon'
                    : type_validation == 'danger'
                      ? 'XCircleIcon'
                      : 'AlertTriangleIcon',
                //       : type_assign == 'Validation'
                //         ? 'UploadCloudIcon'
                //         : 'AlertTriangleIcon'
              })
            console.log(x)
            x.gmaps_url = `https://www.google.com/maps/search/?api=1&query=${x.latitude},${x.longitude}`
            x.streetview_url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${x.latitude},${x.longitude}`
          })
          this.last_page = res.data.data.last_page
          this.data = tmp

          this.data.forEach(async (x, index) => {
            try {
              const tmp = await this.getAddress(x.latitude, x.longitude)
              //
              this.$set(this.data, index, { ...x, address: tmp.display_name })
            } catch (err) {
              console.error(err)
              this.$set(this.data, index, { ...x, address: '' })
            }
          })
          //

          this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          this.$vs.loading.close('#isi_table > .con-vs-loading')
          this.load_done = true
        })
        .catch((err) => {
          //
        })
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)

      //
      return tmp.data
    },
    signInFirebase() {
      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          //
        })
    },
    handleSelected(tr) {
      if (
        tr.verified_by.type == 'danger' &&
        tr.validation_by.type_validation == 'danger'
      ) {
        this.$toast.error(`This data is expired and can not be verified!`, {
          duration: 3000,
        })
        return
      }

      // this.editMode = true
      this.selectedAlertId = tr._id
      this.selectedAlertImei = tr.imei
      this.editMode = true
      this.titleModal = 'Verification Notes'
      this.dataEdit = JSON.parse(JSON.stringify(tr))
      this.eventType = tr.event_type
      //
      this.openModal = true
      //
    },
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    },
    closeModal() {
      this.openModal = false
      this.editMode = false
      // this.openBulkModal = false
      // this.confirmDelete = false
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.listPaired = []
      this.fleetGroup = ''
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
  },
}
</script>

<style>
:root {
  --primary: rgba(123, 168, 255, 0.1);
  --warning: rgba(248, 190, 41, 0.1);
  --last-warning: rgba(242, 153, 74, 0.1);
  --last-validation: rgba(242, 153, 74, 0.1);
  --validation: rgba(242, 153, 74, 0.1);
  --danger: rgba(235, 87, 87, 0.1);
  --success: rgba(58, 151, 76, 0.1);
  --primary-content: rgba(123, 168, 255, 1);
  --warning-content: rgba(248, 190, 41, 1);
  --last-warning-content: rgba(242, 153, 74, 1);
  --validation-content: rgba(242, 153, 74, 1);
  --last-validation-content: rgba(242, 153, 74, 1);
  --danger-content: rgba(235, 87, 87, 1);
  --success-content: rgba(58, 151, 76, 1);
}

.loader_1 {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}

.datepicker {
  right: 0;
}

.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: flex !important;
}

.date-popup > .vs-popup > .vs-popup--content {
  overflow: visible;
}

.heights {
  width: 100%;
  height: calc(100vh - 15.1rem);
}

.custom-search {
  position: absolute;
  width: 50%;
  right: 7px;
  top: 2px;
  z-index: 3;
}

.cursor {
  cursor: pointer;
}

#data-list-list-view > div.con-vs-tabs.vs-tabs.vs-tabs-primary.vs-tabs-position-top > div.con-slot-tabs > div > div.vs-row > div > div > nav > ul > li.item-pagination.vs-pagination--li{
  margin: 0px 10px;
}

.custom-datetime-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.custom-date-input {
  flex: 1;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #fff;
  font-size: 0.9rem;
}

.custom-time-picker {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.625rem 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  min-width: 90px;
  background-color: #fff;
  transition: border-color 0.2s ease;
}

.custom-time-picker:hover {
  border-color: #ea5455;
}

.time-display {
  font-weight: 600;
  color: #374151;
}

.clock-icon {
  color: #6b7280;
}

.time-picker-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.time-picker-modal {
  width: 320px;
  max-width: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.time-picker-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}

.time-picker-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
}

.time-picker-body {
  padding: 16px 20px;
}

.time-scroll-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
}

.time-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.time-column-header {
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.time-scroll {
  height: 200px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  padding: 4px;
}

.time-scroll::-webkit-scrollbar {
  width: 6px;
}

.time-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.time-scroll::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.time-scroll::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.time-item {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.15s ease;
  user-select: none;
  font-family: 'Courier New', monospace;
}

.time-item:hover {
  background: #e5e7eb;
  color: #111827;
}

.time-item.active {
  background: #ea5455;
  color: #ffffff;
  box-shadow: 0 2px 10px rgba(234, 84, 85, 0.35);
}

.time-separator {
  font-size: 28px;
  font-weight: 600;
  color: #ea5455;
  font-family: 'Courier New', monospace;
  margin-top: 28px;
}

.time-picker-footer {
  padding: 16px 20px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.time-btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.time-btn.time-btn-cancel {
  background: #f3f4f6;
  color: #374151;
}

.time-btn.time-btn-cancel:hover {
  background: #e5e7eb;
}

.time-btn.time-btn-confirm {
  background: #ea5455;
  color: #ffffff;
}

.time-btn.time-btn-confirm:hover {
  background: #d13f41;
  box-shadow: 0 4px 12px rgba(234, 84, 85, 0.35);
}
</style>
